(($, Drupal) => {
  "use strict";

  Drupal.behaviors.questionModalScrollTop = {
    attach(context) {
      // Scroll to top when changing modal question
      const isTargetContext =
        $(context).is(".plume-quiz__ajax-wrapper") ||
        $(context).is(".modal-content");

      if (isTargetContext) {
        $(".modal-content").animate({ scrollTop: 0 }, "slow");
      }
    },
  };
})(jQuery, Drupal);
